import { Component, AfterViewChecked, ChangeDetectorRef } from '@angular/core';
import { UszkodzenieZKomentarzemBaseComponent } from '../uszkodzenie-z-komentarzem-base.component';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { NavigationService } from '../../../../../../../shared/services/navigation/navigation.service';
import { FormularzUszkodzenService } from '../../../../../../../shared/components/proces-uszkodzen/zgloszenie/ubezpieczenie/podsumowanie/lista-przedmiotow/rodzaj-elementu/uszkodzenia/formularz-uszkodzen.service';
import { UuidGeneratorService } from '../../../../../../../shared/services/id-generator/uuid-generator.service';
import { ParametryZbioruUszkodzen, Uszkodzenie, ZbiorUszkodzen, ParametryInnegoPrzedmiotu } from '../../../../../../../shared/store/zbior-uszkodzen/zbiorUszkodzen';
import { SlownikUszkodzen } from '../../../../../../../shared/model/uszkodzenia/slownik-uszkodzen';
import { LokalizacjaUszkodzenia } from '../../../../../../../shared/model/uszkodzenia/lokalizacja-uszkodzenia';
import { aktualizujZbiorUszkodzen } from '../../../../../../../shared/store/zbior-uszkodzen/zbiorUszkodzen.actions';

@Component({
  selector: 'app-inne',
  templateUrl: './inne.component.html',
  styleUrls: ['./inne.component.scss']
})
export class InneComponent extends UszkodzenieZKomentarzemBaseComponent implements AfterViewChecked {

  constructor(
    route: ActivatedRoute,
    store: Store,
    navigation: NavigationService,
    formularzUszkodzenService: FormularzUszkodzenService,
    private changeDetector: ChangeDetectorRef,
    idGenerator: UuidGeneratorService
  ) {
    super(route, store, navigation, formularzUszkodzenService, idGenerator);
  }

  zapiszKomentarz(): void {
    const parametry = {} as ParametryZbioruUszkodzen;
    const uszkodzenie = {} as Uszkodzenie<ParametryInnegoPrzedmiotu>;
    uszkodzenie.identyfikator = this.idGenerator.generateUuId();
    uszkodzenie.nazwa = SlownikUszkodzen.INNE.nazwa;
    uszkodzenie.opis = SlownikUszkodzen.INNE.opis;
    uszkodzenie.elementyUszkodzone = [];
    uszkodzenie.parametry = {
      jednostka: '',
      wartosc: 0,
      komentarz: this.formularzUszkodzenia.controls.komentarz.value
    };
    this.utworzLubAktualizujZbiorUszkodzen(parametry, [uszkodzenie]);
  }

  private utworzLubAktualizujZbiorUszkodzen(parametryZbioruUszkodzen: ParametryZbioruUszkodzen, uszkodzenia: Uszkodzenie<ParametryInnegoPrzedmiotu>[]): void {
    const zbiorUszkodzen = {} as ZbiorUszkodzen;
    zbiorUszkodzen.id = this.idZbioruUszkodzen ?? this.idGenerator.generateUuId();
    zbiorUszkodzen.lokalizacja = LokalizacjaUszkodzenia.INNE.name;
    zbiorUszkodzen.opisLokalizacji = LokalizacjaUszkodzenia.INNE.label;
    zbiorUszkodzen.parametry = parametryZbioruUszkodzen;
    zbiorUszkodzen.uszkodzenia = uszkodzenia;
    this.store.dispatch(aktualizujZbiorUszkodzen({ przedmiotId: this.idPrzedmiotuUbezpieczenia, zbiorUszkodzen }));
  }

  ngAfterViewChecked(): void {
    this.changeDetector.detectChanges();
  }
}
